<div class="page">

  <div class="page-header">
    <div class="header-left">
      <button class="btn-back" (click)="goBack()">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="15 18 9 12 15 6"/>
        </svg>
        Back
      </button>
      <div>
        <h1>New Banner</h1>
        <p>Media, caption and where it opens — placed in the app by slot</p>
      </div>
    </div>
  </div>

  <div class="error-msg" *ngIf="errorMessage">
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/>
      <line x1="12" y1="16" x2="12.01" y2="16"/>
    </svg>
    {{ errorMessage }}
  </div>

  <form class="form-card" (ngSubmit)="onSubmit()">

    <app-banner-fields [form]="form" [developers]="developers"></app-banner-fields>

    <div class="form-divider"></div>

    <div class="form-actions">
      <button type="button" class="btn-secondary" (click)="goBack()">Cancel</button>
      <button type="submit" class="btn-primary" [disabled]="isSubmitting">
        <span *ngIf="!isSubmitting">Create Banner</span>
        <span *ngIf="isSubmitting" class="spinner-sm"></span>
      </button>
    </div>

  </form>
</div>
